export default __webpack_public_path__ + "static/media/isoftbet.1180edc3.png";